import { render, staticRenderFns } from "./MoreProducts.vue?vue&type=template&id=aff9d4d6&scoped=true"
import script from "./MoreProducts.vue?vue&type=script&lang=js"
export * from "./MoreProducts.vue?vue&type=script&lang=js"
import style0 from "./MoreProducts.vue?vue&type=style&index=0&id=aff9d4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff9d4d6",
  null
  
)

export default component.exports